var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import copy from 'clipboard-copy';
import _ from 'lodash';
import { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { reset } from 'redux-form';
import { apiCreateSlideBoards as apiCreateSlideBoardsAction, apiDeleteManySlideBoardClips as apiDeleteManySlideBoardClipsAction, apiDeleteManySlideBoards as apiDeleteManySlideBoardsAction, apiDeleteSlideClip as apiDeleteSlideClipAction, apiGetSlideClips as apiGetSlideClipsAction, apiGetSlideBoards as apiGetSlideBoardsAction, } from '../../../../actions/AttachmentSlideActions';
import { MODAL_TYPE_CLIENT_CREATE_BOARD, hideModal as hideModalAction, showModal as showModalAction, } from '../../../../actions/ModalActions';
import { showNotification as showNotificationAction } from '../../../../actions/NotificationActions';
import { propFunc } from '../../../../helpers/custom-prop-types';
import ModalCreateBoard from '../Modal/ModalCreateBoard';
import MyFavoriteBoardTab from './MyFavoriteBoardTab';
import MyFavoriteClipTab from './MyFavoriteClipTab';
import MyFavoriteSlideTabSwitch from './MyFavoriteSlideTabSwitch';
class MyFavoriteSlides extends Component {
    constructor(props) {
        super(props);
        this.updateState = (state) => {
            if (!this.unmount) {
                this.setState(state);
            }
        };
        this.loadClips = (lastId) => __awaiter(this, void 0, void 0, function* () {
            const { clipList } = this.state;
            const { apiGetSlideClips } = this.props;
            this.updateState({ clipIsLoading: true });
            try {
                if (!lastId) {
                    this.updateState({ clipChecks: [] });
                }
                const res = yield apiGetSlideClips(lastId);
                const { payload: { list }, total, } = res;
                const newList = lastId ? [...clipList, ...list] : [...list];
                this.updateState({
                    clipIsHasMore: total > newList.length,
                    clipList: newList,
                });
            }
            finally {
                this.updateState({ clipIsLoading: false });
            }
        });
        this.loadClipsMore = () => __awaiter(this, void 0, void 0, function* () {
            const { clipList } = this.state;
            yield this.loadClips(clipList[clipList.length - 1].id);
        });
        this.loadBoards = (lastId) => __awaiter(this, void 0, void 0, function* () {
            const { boardList } = this.state;
            const { apiGetSlideBoards } = this.props;
            this.updateState({ boardIsLoading: true });
            try {
                if (!lastId) {
                    this.updateState({ boardList: [] });
                }
                const res = yield apiGetSlideBoards(lastId);
                const { payload: { list }, total, } = res;
                const newList = lastId ? [...boardList, ...list] : [...list];
                this.updateState({
                    boardIsHasMore: total > newList.length,
                    boardList: newList,
                });
            }
            finally {
                this.updateState({ boardIsLoading: false });
            }
        });
        this.loadBoardsMore = () => __awaiter(this, void 0, void 0, function* () {
            const { boardList } = this.state;
            yield this.loadBoards(boardList[boardList.length - 1].id);
        });
        this.onChange = (e) => {
            const { checked, name, value } = e.currentTarget;
            const accessName = {
                board: 'boardChecks',
                boardClip: 'boardClipChecks',
                clip: 'clipChecks',
            }[name];
            const { [accessName]: checks } = this.state;
            const id = parseInt(value, 10);
            if (checked) {
                this.updateState({ [accessName]: [...checks, id] });
            }
            else {
                this.updateState({ [accessName]: checks.filter((v) => v !== id) });
            }
        };
        this.onClickCreateBoard = () => {
            const { resetModal, showModal } = this.props;
            resetModal();
            showModal();
        };
        this.onSubmitModal = (values) => __awaiter(this, void 0, void 0, function* () {
            const { apiCreateSlideBoards, hideModal } = this.props;
            const { clipChecks } = this.state;
            try {
                this.updateState({ boardIsCreating: true });
                yield apiCreateSlideBoards(Object.assign(Object.assign({}, values), { clips: clipChecks }));
                this.updateState({ clipChecks: [] });
                // board引き直し
                yield this.loadBoards();
                // モーダル閉じる
                hideModal();
            }
            finally {
                this.updateState({ boardIsCreating: false });
            }
        });
        this.onClickDeleteClip = () => __awaiter(this, void 0, void 0, function* () {
            const { apiDeleteSlideClip } = this.props;
            const { clipChecks, clipList } = this.state;
            try {
                this.updateState({
                    clipChecks: [],
                    clipIsDeleting: true,
                    clipList: clipList.filter((v) => !clipChecks.includes(v.slidePageId)),
                });
                yield apiDeleteSlideClip(clipChecks.join(','));
                yield this.loadBoards();
            }
            finally {
                this.updateState({ clipIsDeleting: false });
            }
        });
        this.onClickDeleteBoard = () => __awaiter(this, void 0, void 0, function* () {
            const { apiDeleteManySlideBoards } = this.props;
            const { boardChecks, boardList } = this.state;
            try {
                this.updateState({
                    boardIsDeleting: true,
                });
                yield apiDeleteManySlideBoards(boardChecks.join(','));
                this.updateState({
                    boardChecks: [],
                    boardList: boardList.filter((v) => !boardChecks.includes(v.id)),
                });
            }
            finally {
                this.updateState({ boardIsDeleting: false });
            }
        });
        this.onClickDeleteBoardClips = () => __awaiter(this, void 0, void 0, function* () {
            const { apiDeleteManySlideBoardClips } = this.props;
            const { boardClipChecks, boardList, showBoard } = this.state;
            try {
                this.updateState({ boardClipsIsDeleting: true });
                // 削除の実行
                yield apiDeleteManySlideBoardClips(showBoard.id, boardClipChecks.join(','));
                const newShowBoard = Object.assign(Object.assign({}, showBoard), { clips: showBoard.clips.filter((clip) => !boardClipChecks.includes(clip.id)) });
                if (newShowBoard.clips.length > 0) {
                    const updateBoard = boardList.find((board) => board.id === newShowBoard.id);
                    updateBoard.clips = newShowBoard.clips;
                    this.updateState({
                        boardClipChecks: [],
                        boardList: [...boardList],
                        showBoard: newShowBoard,
                    });
                }
                else {
                    this.updateState({
                        boardClipChecks: [],
                        boardList: boardList.filter((board) => board.id !== showBoard.id),
                        showBoard: null,
                    });
                }
            }
            finally {
                this.updateState({ boardClipsIsDeleting: false });
            }
        });
        this.onClickCopy = () => __awaiter(this, void 0, void 0, function* () {
            const { showNotification } = this.props;
            const { boardChecks, boardClipChecks, boardList, clipChecks, clipList, showBoard, showMode, } = this.state;
            let clips;
            if (showMode === 'clip') {
                clips = clipList.filter((clip) => clipChecks.includes(clip.slidePageId));
            }
            else if (showBoard) {
                clips = showBoard.clips.filter((clip) => boardClipChecks.includes(clip.id));
            }
            else {
                clips = _.flatten(boardList
                    .filter((board) => boardChecks.includes(board.id))
                    .map((board) => board.clips));
            }
            const base = `${window.location.protocol}//${window.location.host}/consultant/slide/page`;
            const urlList = clips.map(({ slidePageId }) => `${base}/${slidePageId}`);
            yield Promise.all([
                copy(urlList.join('\n')),
                showNotification('コピーしました。'),
            ]);
        });
        this.onClickBoard = (e) => {
            const { value: boardId } = e.currentTarget;
            const { boardList } = this.state;
            const id = parseInt(boardId, 10);
            const showBoard = boardList.find((board) => board.id === id);
            if (!showBoard) {
                return;
            }
            this.updateState({
                boardClipChecks: [],
                showBoard,
            });
        };
        this.onClickReset = () => {
            this.updateState({
                boardClipChecks: [],
                showBoard: null,
            });
        };
        this.onChangeTab = (e) => {
            const { value } = e.currentTarget;
            this.updateState({
                showBoard: null,
                showMode: value,
            });
        };
        this.state = {
            boardChecks: [],
            boardClipChecks: [],
            boardClipsIsDeleting: false,
            boardIsDeleting: false,
            boardIsHasMore: false,
            boardIsLoading: false,
            boardList: [],
            clipChecks: [],
            clipIsDeleting: false,
            clipIsHasMore: false,
            clipIsLoading: false,
            clipList: [],
            showBoard: null,
            showMode: 'clip',
        };
        this.unmount = false;
    }
    componentDidMount() {
        Promise.all([this.loadClips(), this.loadBoards()]).then();
    }
    componentWillUnmount() {
        this.unmount = true;
    }
    render() {
        const { boardChecks, boardClipChecks, boardClipsIsDeleting, boardIsDeleting, boardIsHasMore, boardIsLoading, boardList, clipChecks, clipIsDeleting, clipIsHasMore, clipIsLoading, clipList, showBoard, showMode, } = this.state;
        return (_jsxs("div", Object.assign({ className: 'l-container-12' }, { children: [_jsxs("div", Object.assign({ className: 'content-box content-box-favorite-slide' }, { children: [_jsx("h3", { children: "\u304A\u6C17\u306B\u5165\u308A\u30B9\u30E9\u30A4\u30C9" }), _jsx(MyFavoriteSlideTabSwitch, { onClick: this.onChangeTab, showMode: showMode }), _jsx(MyFavoriteClipTab, { checks: clipChecks, isDeleting: clipIsDeleting, isHasMore: clipIsHasMore, isLoading: clipIsLoading, isShow: showMode === 'clip', lists: clipList, onChangeCheck: this.onChange, onClickCopy: this.onClickCopy, onClickCreate: this.onClickCreateBoard, onClickDelete: this.onClickDeleteClip, onClickMore: this.loadClipsMore }), _jsx(MyFavoriteBoardTab, { boardClipChecks: boardClipChecks, checks: boardChecks, isBoardClipsDeleting: boardClipsIsDeleting, isDeleting: boardIsDeleting, isHasMore: boardIsHasMore, isLoading: boardIsLoading, isShow: showMode === 'board', lists: boardList, onChangeCheck: this.onChange, onClickBoard: this.onClickBoard, onClickCopy: this.onClickCopy, onClickDelete: this.onClickDeleteBoard, onClickDeleteBoardClips: this.onClickDeleteBoardClips, onClickMore: this.loadBoardsMore, onClickReset: this.onClickReset, showBoard: showBoard })] })), _jsx(ModalCreateBoard, { handleSubmit: this.onSubmitModal })] })));
    }
}
MyFavoriteSlides.propTypes = {
    apiCreateSlideBoards: propFunc().isRequired,
    apiDeleteManySlideBoardClips: propFunc().isRequired,
    apiDeleteManySlideBoards: propFunc().isRequired,
    apiDeleteSlideClip: propFunc().isRequired,
    apiGetSlideBoards: propFunc().isRequired,
    apiGetSlideClips: propFunc().isRequired,
    hideModal: propFunc().isRequired,
    resetModal: propFunc().isRequired,
    showModal: propFunc().isRequired,
    showNotification: propFunc().isRequired,
};
const mapDispatchToProps = (dispatch) => ({
    apiCreateSlideBoards: (params) => new Promise((resolve, reject) => {
        dispatch(apiCreateSlideBoardsAction(params, { reject, resolve }));
    }),
    apiDeleteManySlideBoardClips: (boardId, clipIds) => new Promise((resolve, reject) => {
        dispatch(apiDeleteManySlideBoardClipsAction(boardId, clipIds, {
            reject,
            resolve,
        }));
    }),
    apiDeleteManySlideBoards: (boardIds) => new Promise((resolve, reject) => {
        dispatch(apiDeleteManySlideBoardsAction(boardIds, { reject, resolve }));
    }),
    apiDeleteSlideClip: (ids) => new Promise((resolve, reject) => {
        dispatch(apiDeleteSlideClipAction(ids, { reject, resolve }));
    }),
    apiGetSlideBoards: (lastId) => new Promise((resolve, reject) => {
        const params = {};
        if (lastId) {
            params.less_than = lastId;
        }
        dispatch(apiGetSlideBoardsAction(params, { reject, resolve }));
    }),
    apiGetSlideClips: (lastId) => new Promise((resolve, reject) => {
        const params = {};
        if (lastId) {
            params.less_than = lastId;
        }
        dispatch(apiGetSlideClipsAction(params, { reject, resolve }));
    }),
    hideModal: () => dispatch(hideModalAction(MODAL_TYPE_CLIENT_CREATE_BOARD)),
    resetModal: () => dispatch(reset('FormCreateBoard')),
    showModal: () => dispatch(showModalAction(MODAL_TYPE_CLIENT_CREATE_BOARD)),
    showNotification: (message) => dispatch(showNotificationAction(message)),
});
const enhance = compose(connect(null, mapDispatchToProps));
export default enhance(MyFavoriteSlides);
